import { downloadAllData } from "utils/statistic";
import styles from "./startPage.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import AllDataFilterPopup from "../statisticPopup/allDataFilterPopup";
import { useState } from "react";

interface StartPageProps {
    onNavigateToStatistik: () => void;
}

export default function StartPage({ onNavigateToStatistik }: StartPageProps) {
    const [isAllDataFilterPopupOpen, setIsAllDataFilterPopupOpen] = useState(false);

    return (<>
        <AllDataFilterPopup isPopupOpen={isAllDataFilterPopupOpen} onClose={()=>setIsAllDataFilterPopupOpen(false)}/>
        <div className={styles.container}>
            <div className={styles.rightSction}>
                <button
                    className={`${commonStyles.commonButton} ${styles.downloadButton}`}
                    onClick={() => setIsAllDataFilterPopupOpen(true)}
                >
                    <p>Alle Daten herunterladen</p>
                </button>
                <p className={styles.rightSctionText}>
                    Hier können alle statistischen Daten im CSV-Format heruntergeladen werden
                </p>
            </div>

            <div className={styles.leftSction}>
                <button
                    className={`${commonStyles.commonButton} ${styles.otherStaticButton}`}
                    onClick={onNavigateToStatistik}
                >
                    <p>Zu den weiteren Auswertungen</p>
                </button>
            </div>
        </div>
    </>
    );
}
